import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import { StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { appendURlWithParam, isMobile, setAppHeader } from '../../configs/utils';
import { ACTION } from "../partnerWeb_Dashboard/types";
import { PartnerHeader } from "../partnerWeb_Dashboard/partnerHeader";
import { SideBarBuilderDS } from "../sideNavBar";
import { getOTP, onChangeInputOtp, onChangeTab } from "./action";
import { BottomNavBuilderDS } from "../bottomNav";
import { GoToFaq, GoToHome, GoToPhone } from "../partnerSignUp/actions";
import { handleConnection, onLogoutPress } from "../partnerWeb_Dashboard/actions";
import { PARTNER_FOOTER_HEIGHT, PARTNER_HEADER_HEIGHT } from "../../configs/constants";
import { navigate } from "../partnerMobMenu/actions";
import { ShowNewRmContactButton } from '../partnerWeb_Dashboard/utils';
import { getAppHeader } from '../../configs/config';
import { partnerApi } from '../../configs/api';
import AsyncStorage from '@react-native-async-storage/async-storage';
const _isMobile = isMobile();
export const template = async (height, metaData, leadData, showNewRmContactButton, rmData, isFromMobile) => ({
    layout: {
        id: ROUTE.PARTNER_CHECK_CUSTOMER_PORFOLIO,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            {
                id: 'partnerHeader',
                type: WIDGET.STACK,
                position: POSITION.ABSOLUTE_TOP,
            },
            showNewRmContactButton ? { id: 'rmContactButton', type: WIDGET.RM_CONTACT_LIST, position: POSITION.ABSOLUTE_BOTTOM } : {},
            !isMobile()
                ? {
                    id: 'sideNav',
                    type: WIDGET.STACK,
                    position: POSITION.NAVBAR_LEFT,
                }
                : {},
            { id: 'customerPortfolioMainStack', type: WIDGET.STACK },
            isFromMobile ? { id: 'BottomNavContainer', type: WIDGET.STACK, position: POSITION.ABSOLUTE_BOTTOM } : {}
        ]
    },
    datastore: {
        rmContactButton: {
            title: 'Contact us',
            rmData,
            containerWidth: StackWidth.MATCH_PARENT,
            handleRmConnection: {
                routeId: ROUTE.PARTNER_CHECK_CUSTOMER_PORFOLIO,
                type: ACTION.HANDLE_CONNECTION,
                payload: {}
            }
        },
        ...await PartnerHeader(ROUTE.PARTNER_CHECK_CUSTOMER_PORFOLIO),
        ...await SideBarBuilderDS(ROUTE.PARTNER_CHECK_CUSTOMER_PORFOLIO),
        ...await BottomNavBuilderDS(ROUTE.PARTNER_CHECK_CUSTOMER_PORFOLIO),
        customerPortfolioMainStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'customerPortfolioPage', type: WIDGET.PARTNER_CUSTOMER_PORTFOLIO_DETAILS }
            ]
        },
        customerPortfolioPage: {
            height: _isMobile ?
                (height - PARTNER_HEADER_HEIGHT - PARTNER_FOOTER_HEIGHT) :
                (height - PARTNER_HEADER_HEIGHT),
            getOtpAction: {
                routeId: ROUTE.PARTNER_CHECK_CUSTOMER_PORFOLIO,
                type: ACTION.GET_OTP,
                payload: {}
            },
            submitOtpAction: {
                routeId: ROUTE.PARTNER_CHECK_CUSTOMER_PORFOLIO,
                type: ACTION.CHANGE_OTP,
                payload: {}
            },
            metaData: metaData,
            assetDetails: leadData,
            activeScreen: leadData ? "DATA_TABLE_SCREEN" /* CHECK_CUSTOMER_PORTFOLIO_SCREEN_TYPE.DATA_TABLE_SCREEN */ : "PHONE_PAN_SCREEN" /* CHECK_CUSTOMER_PORTFOLIO_SCREEN_TYPE.PHONE_PAN_SCREEN */
        }
    },
});
export const customerPortfolioMF = {
    onLoad: async ({ asyncStorage, metaData, getHeight, network, instrumentTrack, ...props }) => {
        appendURlWithParam('view-customer-portfolio');
        await setAppHeader();
        const height = getHeight();
        const leadData = JSON.parse(await asyncStorage.get('leadData'));
        let showNewRmContactButton = false;
        showNewRmContactButton = await ShowNewRmContactButton();
        const header = await getAppHeader();
        const user = await AsyncStorage.getItem("user_context");
        const userData = await JSON.parse(user);
        const partnerAccountId = userData?.linkedPartnerAccounts[0].accountId;
        const isFromMobile = isMobile();
        const rmContactResponse = await network.get(`${partnerApi.getMappedRMDetails}${partnerAccountId}`, {
            headers: header
        });
        const rmData = rmContactResponse?.data;
        return Promise.resolve(template(height, metaData, leadData, showNewRmContactButton, rmData, isFromMobile));
    },
    actions: {
        [ACTION.CHANGE_TAB]: onChangeTab,
        [ACTION.CHANGE_OTP]: onChangeInputOtp,
        [ACTION.GO_TO_HOME]: GoToHome,
        [ACTION.GO_TO_FAQ]: GoToFaq,
        [ACTION.GO_TO_CALL]: GoToPhone,
        [ACTION.LOGOUT]: onLogoutPress,
        [ACTION.NAVIGATE]: navigate,
        [ACTION.GET_OTP]: getOTP,
        [ACTION.HANDLE_CONNECTION]: handleConnection,
    }
};
